<template>
  <zm-radio-group
    v-bind="$attrs"
    :model-value="innerValue"
    :before-change="handleRadioGroupInput"
  >
    <slot
      v-for="slot in Object.keys({...$slots})"
      :key="slot"
      :name="slot"
      v-bind="$slots[slot].scope || {}"
    ></slot>
  </zm-radio-group>
</template>
<script>
import { logger } from '@/utils/log';

export default {
  name: 'zb-radio-group',
  props: {
    modelValue: [String, Number, Boolean, Array],
    action: Function,
  },
  emits: ['update:modelValue', 'change', 'input'],
  data() {
    return {
      innerValue: '',
      nextValue: '',
    };
  },
  methods: {
    async handleRadioGroupInput(done, value) {
      try {
        this.nextValue = value;
        this.innerValue = this.modelValue;
        if (this.action) {
          await this.action.call(this, this.modelValue, this.nextValue);
        }
        done(true);
        this.$emit('input', this.nextValue);
        this.$emit('update:modelValue', this.nextValue);
        this.innerValue = this.nextValue;
        this.$emit('change', this.nextValue);
      } catch (e) {
        logger.warn('before-change-radio', e);
        done(false);
      }
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler() {
        this.innerValue = this.modelValue;
      },
    },
  },
};
</script>
